export default {
  data: function () {
    return {
    }
  },
  created: function () {
  },
  methods: {
    teamsGetContext: async function () {
      let self = this;
      this.$store.dispatch("user/logInfo", "teamsGetContext");
      let context = await new Promise((resolve) => {
        self.microsoftTeams.app.getContext().then((context) => {
          resolve(context);
        });
      });      
      this.$store.dispatch("teams/context", context);
    },
    graphRest_isAuthenticated: async function (fetchUser) {
      try {
        let result = await this.$http.get("/graph/rest/isAuthenticated", {
          timeout: 5000 
        });
        this.teamsSetAuthenticated(result.data.email, fetchUser);
        console.log("graphRest_isAuthenticated true");
        return true;
      } catch (error) {
        console.log("graphRest_isAuthenticated false");
        if (error.response.data.message != undefined) {
          throw(error.response.data.message);
        }else{
          throw(null);
        }
      }
    },
    graphRest_registerToken: async function(token, fetchUser) {
      try {
        let result = await this.$http.post("/graph/rest/registerToken", {
          code: token
        });
        this.teamsSetAuthenticated(result.data.email, fetchUser);
        return true;
      } catch (error) {
        if (error.response.data.message != undefined) {
          throw(error.response.data.message);
        }else{
          throw(null);
        }
      }
    },
    teamsElevation: async function() {
      let self = this;
      let authenticateResult = await new Promise((resolve) => {
        self.microsoftTeams.authentication.authenticate({
          url: process.env.VUE_APP_URL + "/graph/rest/authenticate",
          width: 600,
          height: 535,
          successCallback: function () {
            resolve(null);
          },
          failureCallback: function () {
            resolve(self.teamsCheckAuthenticated());
          }
        });
      });
      return authenticateResult
    },
    teamsGetToken: async function () {
      let self = this;
      return await new Promise((resolve) => {
        self.microsoftTeams.authentication.getAuthToken({
          successCallback: async function (result) {
            resolve(result);
          },
          failureCallback: async function () {
            resolve(null);
          }
        });
      });
    },
    teamsSetAuthenticated: async function (email, fetchUser) {
      await this.$store.dispatch("teams/authenticated", true);
      await this.$store.dispatch("user/setEmail", email);
      await this.$store.dispatch("user/fetchHostname");
      await this.$store.dispatch("user/fetchVersion");
      if(fetchUser)
      {
        await this.$store.dispatch("user/fetchUser");
      }
    },
    teamsCheckAuthenticated: async function (fetchUser = true) {
      await this.teamsGetContext();
      try {
        await this.graphRest_isAuthenticated(fetchUser);
      } catch (error) {
        try {
          let token = await this.teamsGetToken();
          await this.graphRest_registerToken(token, fetchUser);
        } catch (error) {
          if(error == "ELEVATION_NEEDED")
          {
            return this.teamsElevation();
          }
        }
      }
    }
  }
};